export default __webpack_public_path__ + "static/the-block-c052775a9c38571ea2333488c4ed3376.png";